import {FETCH_TAXSUMMARY_BEGIN,FETCH_TAXSUMMARY_SUCCESS,FETCH_TAXSUMMARY_FAILURE} from '../constants/taxsummary';

const initialState={
    taxSummary:{},
    isLoading:false,
    error:""
}


export const getTaxSummaryReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_TAXSUMMARY_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_TAXSUMMARY_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            taxSummary:payload.taxSummary
        };
    case FETCH_TAXSUMMARY_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getTaxSummaryReducer
